var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column align-center justify-center pa-2",attrs:{"flat":"","link":"","color":"transparent","width":"fit-content"}},[_c('v-icon',{staticStyle:{"opacity":"0.7"},attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]),_c('p',{staticClass:"mb-0 mt-1"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }